<template>
  <div class="animated fadeIn">
    <Tables ref="tableGrid"
      :columns="[
        'Contrato Credito',
        'Situacao Contrato',
        'Valor Contrato',
        'Saldo Devedor',
        'Valor Garantia',
        'Percentual Garantia',
        'Percentual Garantia Atual',
        'Grupo Garantia',
        'CPF Garantidor',
        'Nome Garantidor',
        'Nome Grupo',
        'Garantia Enquadramento',
        'Tipo Garantia Enquadramento']"
      :showTipFooter="false"
      v-on:Load="onLoad">
      <tr v-for="obj in this.objList" v-bind:key="obj.id">
        <TableColumn :IsText="true" :status="1" :value="obj.contratoCredito ? obj.contratoCredito.toString() : ''" />
        <TableColumn :IsText="true" :status="1" :value="obj.situacaoContrato" />
        <TableColumn :IsText="true" :status="1" :value="obj.valorContrato ? formatValue(obj.valorContrato) : 'R$ 0,00'" />
        <TableColumn :IsText="true" :status="1" :value="obj.saldoDevedor ? formatValue(obj.saldoDevedor) : 'R$ 0,00'" />
        <TableColumn :IsText="true" :status="1" :value="obj.valorGarantia ? formatValue(obj.valorGarantia) : 'R$ 0,00'" />
        <TableColumn :IsText="true" :status="1" :value="obj.percentualGarantia ? `${obj.percentualGarantia}%`: '0%'" />
        <TableColumn :IsText="true" :status="1" :value="obj.percentualGarantiaAtual ? `${obj.percentualGarantiaAtual}%`: '0%'" />
        <TableColumn :IsText="true" :status="1" :value="obj.grupoGarantia" />
        <TableColumn :IsText="true" :status="1" :value="formatValueCPF(obj.cpfGarantidor)" />
        <TableColumn :IsText="true" :status="1" :value="obj.nomeGarantidor" />
        <TableColumn :IsText="true" :status="1" :value="obj.nomeGrupo" />
        <TableColumn :IsText="true" :status="1" :value="obj.garantiaEnquadramento" />
        <TableColumn :IsText="true" :status="1" :value="obj.tipoGarantiaEnquadramento" />
      </tr>
    </Tables>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'
import Tools from '@/components/tools/Tools.js'
import OperationsGuaranteeRepository from '@/shared/http/repositories/business/operationsguarantee.js'

export default {
  name: 'OperationsGuarantee',
  mixins: [ActionsForm],
  data () {
    return {
      document: null
    }
  },
  methods: {
    onLoad () {
      if (this.document) {
        this.onLoadOperationsGuarantee(this.document)
      }
    },
    onLoadOperationsGuarantee (document) {
      loading.push()
      this.document = document
      OperationsGuaranteeRepository.Search(document, this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
        .then((response) => {
          this.onResultGrid(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    formatValue (value) {
      let result
      if (value) {
        result = Tools.formatMoneyBR(value.toString())
      }
      return result
    },
    formatValueCPF (value) {
      let result
      if (value) {
        result = Tools.formatCpfCnpj(value, 'PF')
      }
      return result
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/associate/tabs/operationsguarantee.vue